import React, { useState } from 'react'

import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { createUseOrdersQueryParams, useOrdersQuery } from '@hooks/useOrdersQuery'

import { ProductOrdersView } from './ProductOrdersView'
import { SIZE } from './consts'

type Props = {
  offerId: string
}

export const ProductOrdersContainer = ({ offerId }: Props) => {
  const { hasPermission } = useDashboardPermissions()
  const [currentPage, setCurrentPage] = useState(1)
  const { data, ordersQuery } = useOrdersQuery(
    createUseOrdersQueryParams({ currentPage, size: SIZE, offerId }),
    { keepPreviousData: true, enabled: hasPermission('contributions.orders.view') },
  )

  return (
    <ProductOrdersView
      orders={data?.orders}
      isLoading={ordersQuery.isFetching}
      totalPages={data?.page.totalPages}
      currentPage={currentPage}
      onCurrentPageChange={setCurrentPage}
    />
  )
}
